<template>
  <span class="mr-3 ml-3">
    <v-dialog v-model="dialogDocumentTypeDelete" persistent max-width="540">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          color="red darken-3"
          :disabled="!documentType.borrable"
          >{{ icon.trash }}</v-icon
        >
      </template>
      <v-card>
        <v-card-title class="headline">{{
          documentTypeDeleteLabels.questionText.replace(
            '@',
            documentType.nombre
          )
        }}</v-card-title>
        <v-card-text>{{
          documentTypeDeleteLabels.descriptionText
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            id="document_type_delete__eliminar__button"
            text
            @click="onDelete"
            :loading="loading"
            >{{ documentTypeDeleteLabels.positiveButtonText }}</v-btn
          >
          <v-btn
            color="red darken-1"
            id="document_type_delete__cancelar__button"
            text
            @click="dialogDocumentTypeDelete = false"
            :disabled="loading"
            >{{ documentTypeDeleteLabels.negativeButtonText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mdiTrashCanOutline } from '@mdi/js'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

import {
  documentTypeStoreData,
  documentTypeStoreActions
} from '../store/documentTypeStoreHelpers'

export default {
  name: 'DocumentTypeDelete',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icon: {
        trash: mdiTrashCanOutline
      },
      loading: false,
      dialogDocumentTypeDelete: false
    }
  },
  computed: {
    ...documentTypeStoreData,
    documentType() {
      return Object.assign({}, this.value)
    }
  },
  methods: {
    ...documentTypeStoreActions,
    onDelete() {
      this.loading = true

      this.deleteDocumentType(this.documentType.idTipoDocumento)
        .then(result => {
          pushNotification(
            this.$store,
            messageErrorResponse(result) || this.msgDocumentTypeServiceDeleteError,
            result.data.success ? 'info' : 'error',
            'left')
          this.$emit('onUpdate', result)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
          this.dialogDocumentTypeDelete = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentTypeServiceDeleteError,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>
